import { useCoilState } from '@alxshelepenok/diesel';
import { useLocalStorage } from '@alxshelepenok/react-hooks';

const toKebabCase = (str = "") => {
    var _a;
    return ((_a = str
        .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)) === null || _a === void 0 ? void 0 : _a.map(word => word.toLowerCase()).join("-")) || "";
};

const useCoilPersistedState = (coilValue, keyPrefix = "diesel:") => {
    const [value, setValue] = useCoilState(coilValue);
    const [persistedValue, setPersistedValue] = useLocalStorage(keyPrefix.concat(toKebabCase(coilValue.key)), value);
    return [
        persistedValue,
        (nextValue) => {
            setPersistedValue(nextValue);
            return setValue(value);
        },
    ];
};

export { useCoilPersistedState };
//# sourceMappingURL=diesel-extensions.es5.js.map
